<template>
<div class="chapter">
<div class="inner_page">
<h1>Table of Contents</h1>
<p><span href="#/c001" title="Link target outside of Sample">Title Page</span></p>
<p><span href="#/c002" title="Link target outside of Sample">Disclaimer</span></p>
<p><a href="#/c003">The Tin Man (Inner Circle #1) : Enemies to Lovers Dark Romance Thriller (Inner Circle Series, #1)</a></p>
<p><a href="#/c004">Dante Black | Age 18 | San Diego, California U.S.A.</a></p>
<p><a href="#/c005">Dante Black/Parker James | Age 21 | London, England</a></p>
<p><span href="#/c006" title="Link target outside of Sample">Dante Black/Parker James | A Few Weeks Later</span></p>
<p><span href="#/c007" title="Link target outside of Sample">Dante Black/Parker James</span></p>
<p><span href="#/c008" title="Link target outside of Sample">Dante Black/Parker James</span></p>
<p><span href="#/c009" title="Link target outside of Sample">Dante Black/Parker James</span></p>
<p><span href="#/c010" title="Link target outside of Sample">Dante Black/Parker James</span></p>
<p><span href="#/c011" title="Link target outside of Sample">Dante Black/Parker James</span></p>
<p><span href="#/c012" title="Link target outside of Sample">Dante Black/Parker James</span></p>
<p><span href="#/c013" title="Link target outside of Sample">Dante Black/Parker James</span></p>
<p><span href="#/c014" title="Link target outside of Sample">Dante Black/Parker James</span></p>
<p><span href="#/c015" title="Link target outside of Sample">Dante Black/Parker James</span></p>
<p><span href="#/c016" title="Link target outside of Sample">Dante Black/Parker James</span></p>
<p><span href="#/c017" title="Link target outside of Sample">Dante Black/Parker James</span></p>
<p><span href="#/c018" title="Link target outside of Sample">Dante Black/Parker James</span></p>
<p><span href="#/c019" title="Link target outside of Sample">Dante Black/Parker James | A few weeks later</span></p>
<p><span href="#/c020" title="Link target outside of Sample">Dante Black/Parker James</span></p>
<p><span href="#/c021" title="Link target outside of Sample">Dante Black/Parker James</span></p>
<p><span href="#/c022" title="Link target outside of Sample">Dante Black/Parker James</span></p>
<p><span href="#/c023" title="Link target outside of Sample">Katherine/Summer</span></p>
<p><span href="#/c024" title="Link target outside of Sample">M.A.G.E. Series</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?0e7a398a